<mc-table fit="small" disablerowhighlightonhover="true" tabularFigures="true" [data]="rows" [columns]="partsTableColumns">
  @for (row of rows; track row.id) {
    <div [slot]="row.id + '_currentSerialNumbers'">
      <app-tag-input [readOnly]="true" [hiddenLabel]="true" [inputTags]="row.part.currentSerialNumbers ?? []"></app-tag-input>
    </div>
    <div [slot]="row.id + '_newSerialNumbers'">
      <app-tag-input
        [hiddenLabel]="true"
        [readOnly]="!isSerialNumberEditable()"
        [inputTags]="row.part.newSerialNumbers ?? []"
        (values)="onNewSerialNumbersChanged(row.part, $event)">
      </app-tag-input>
    </div>
  }
</mc-table>
